export enum CurrencyEnum {
  NGN = "NGN",
  GHS = "GHS",
  ZAR = "ZAR",
}
